import 'whatwg-fetch';
import { configStore } from '@vfde-fe/sails_core';
import mountHardwareDetailContainer from './container/DeviceDetail';

const store = configStore({});

if (store) {
    mountHardwareDetailContainer();
}
else {
    console.log('no store provided.');
}
